import React from "react"
import { navigate } from "gatsby"
import { renderEmoji, getVariantLabelName, getVariantLabelSlug } from '../../helpers/emoji.js'

export default class NavigateToVariantLink extends React.PureComponent {
  getAnchorName() {
    return getVariantLabelName(this.props.parent_emoji, this.props.emoji);
  }
  getAnchor() {
    return getVariantLabelSlug(this.props.parent_emoji, this.props.emoji);
  }
  render() {
    const emoji = this.props.emoji;
    let linkText = renderEmoji(emoji.codepoints);
    if (!this.props.emoji_only) {
      linkText += ` ${this.getAnchorName()}`;
    }
    return <React.Fragment>
      <a href={`#${this.getAnchor()}`} onClick={(e) => {
        e.preventDefault();
        navigate(`${window.location.pathname}#${this.getAnchor()}`)
      }} dangerouslySetInnerHTML={{
        __html: linkText
      }} aria-label={this.getAnchorName()} />{` `}
    </React.Fragment>;
  }
}
